import React from "react";
import ReactModal from "react-modal";
import "../popups.css";

if (process.env.NODE_ENV !== "test") {
  ReactModal.setAppElement("#root");
}

const ImportErrorModal = ({
  isOpen = false,
  onClose,
  errors = [],
  title = "Import Errors",
  helpNote,
  serverError = null, // optional: { statusCode, message }
}) => {
    console.log("serverError", serverError);
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      style={{
        overlay: { backgroundColor: "rgba(0,0,0,0.35)", zIndex: 1000 },
        content: {
          inset: "auto",
          padding: 0,
          border: "none",
          background: "transparent",
          overflow: "visible",
        },
      }}
    >
      <div id="importdata-popup">
        <div className="importdata-card">
          <div className="importdata-header">
            <h2>{title}</h2>
            <button className="close-btn" onClick={onClose} aria-label="Close">
              &times;
            </button>
          </div>

          {helpNote && (
            <div className="importdata-info" style={{ marginTop: 0 }}>
              <p style={{ marginBottom: 0 }}>{helpNote}</p>
            </div>
          )}

          {(() => {
            // Check if serverError has an errors array (from API response)
            const errorsArray = 
              (serverError && Array.isArray(serverError.errors) ? serverError.errors : null) ||
              (serverError?.error && Array.isArray(serverError.error.errors) ? serverError.error.errors : null) ||
              (Array.isArray(errors) && errors.length > 0 ? errors : null);

            if (errorsArray && errorsArray.length > 0) {
              // Group errors by row
              const groupedByRow = errorsArray.reduce((acc, error) => {
                const row = error?.row ?? error?.line ?? error?.index ?? error?.sr ?? 'Unknown';
                if (!acc[row]) {
                  acc[row] = [];
                }
                acc[row].push(error);
                return acc;
              }, {});

              // Sort rows numerically
              const sortedRows = Object.keys(groupedByRow).sort((a, b) => {
                const numA = parseInt(a);
                const numB = parseInt(b);
                if (isNaN(numA) && isNaN(numB)) return 0;
                if (isNaN(numA)) return 1;
                if (isNaN(numB)) return -1;
                return numA - numB;
              });

              return (
                <div className="importdata-info" style={{ marginTop: 12, width: '100%' }}>
                  <div
                    style={{
                      maxHeight: 400,
                      overflowY: 'auto',
                      border: '1px solid #eee',
                      borderRadius: 8,
                      padding: 16,
                      background: '#fff',
                      width: '100%',
                    }}
                  >
                    <div style={{ fontWeight: 600, marginBottom: 12, color: '#DC2626', fontSize: '18px' }}>
                      {serverError?.message || 'We found the following issues:'}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                      {sortedRows.map((row) => {
                        const rowErrors = groupedByRow[row];
                        return (
                          <div key={row} style={{ 
                            borderLeft: '3px solid #DC2626', 
                            paddingLeft: '12px',
                            marginBottom: '4px'
                          }}>
                            <div style={{ fontWeight: 600, color: '#DC2626', marginBottom: '6px', fontSize: '16px' }}>
                              Row {row} Error
                            </div>
                            <ul style={{ margin: 0, paddingLeft: '20px', listStyle: 'disc' }}>
                              {rowErrors.map((error, idx) => {
                                const msg = error?.error || error?.message || String(error);
                                const field = error?.field || error?.column;
                                return (
                                  <li key={idx} style={{ marginBottom: '4px', color: '#444', fontSize: '15px' }}>
                                    {field && <span style={{ fontWeight: 500 }}>{field}: </span>}
                                    <span>{msg}</span>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              );
            }

            // Fallback: Check for raw message string
            const rawMessage =
              (typeof serverError === 'string' ? serverError : null) ||
              serverError?.message ||
              (typeof errors === 'string' ? errors : null);

            if (rawMessage) {
              // Split into header and detail part at the first colon
              const parts = rawMessage.split(/:(.+)/); // keep text after first colon
              const parsedHeader = parts && parts[0] ? parts[0].trim() : title;
              const detail = parts && parts[1] ? parts[1] : '';
              // Extract entries like: Row N (field: value)
              const matches = detail.match(/Row\s+\d+\s*\([^)]*\)/g) || [];

              return (
                <div className="importdata-info" style={{ marginTop: 12, width: '100%' }}>
                  <div
                    style={{
                      maxHeight: 320,
                      overflowY: 'auto',
                      border: '1px solid #eee',
                      borderRadius: 8,
                      padding: 12,
                      background: '#fff',
                      width: '100%',
                    }}
                  >
                    <div style={{ fontWeight: 600, marginBottom: 8, color: '#DC2626', fontSize: '18px' }}>{parsedHeader}</div>
                    {matches.length > 0 ? (
                      <ul style={{ margin: 0, paddingLeft: 18 }}>
                        {matches.map((item, idx) => (
                          <li key={idx} style={{ marginBottom: 6, color: '#B91C1C', fontSize: '15px' }}>{item}</li>
                        ))}
                      </ul>
                    ) : (
                      <div style={{ color: '#B91C1C', fontSize: '15px' }}>{(detail || rawMessage).trim() || 'No details provided.'}</div>
                    )}
                  </div>
                </div>
              );
            }

            return (
              <div className="importdata-info">
                <p>No errors to display.</p>
              </div>
            );
          })()}

          <div className="importdata-actions" style={{ marginTop: 16 }}>
            <button className="import-confirm-btn" onClick={onClose} style={{ width: 120 }}>
              Close
            </button>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

export default ImportErrorModal;